<template>
  <Stage />
  <News :news="clubNews" origin="general"/>
  <Events origin="general"/>
</template>

<script>
import Stage from "./Stage.vue";
import News from "./News.vue";
import Events from "./Events.vue";

import { onMounted, ref } from "vue";
import axios from 'axios';

export default {
  name: "App",
  components: {
    Stage,
    News,
    Events,
  },
  setup() {

    const clubNews = ref([]);

    const fetchData = async() => {
      try {
        const response = await axios.get('http://localhost:8082/gemeinde/news/news-all-by-clubid/1');
        clubNews.value = response.data;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }

    onMounted(() => {
      fetchData()
    })

    return { clubNews };
  }
}
</script>

<style></style>
